module.exports = __webpack_public_path__ + "static/img/payment_eq_wx.0c5b6db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/payment_eq_wx.png
// module id = xpwc
// module chunks = 0